import { QuestionAnswerRankScoringType } from '@app/src/types/resourceExplorer'

// Assessment scoring types
export const SCORING_TYPES = {
  CUSTOM: QuestionAnswerRankScoringType.Custom,
  DEFAULT: QuestionAnswerRankScoringType.Default,
} as const

// Default assessment points
export const DEFAULT_ASSESSMENT_POINTS = {
  POSITIVE: 1,
  VERY_POSITIVE: 10,
  NEGATIVE: -1,
  NEGATIVE_ADVERSE: -10,
  NEUTRAL: 0,
} as const

// Assessment intervals
export const ASSESSMENT_INTERVALS = {
  MIN: 3,
  MAX: 5,
  DEFAULT: 3,
} as const

// Form validation
export const VALIDATION_LIMITS = {
  ASSESSMENT_NAME_MAX_LENGTH: 255,
  DESCRIPTION_MAX_LENGTH: 1000,
  LEVEL_DESCRIPTION_MAX_LENGTH: 500,
} as const
